import { tss } from 'tss-react/mui';

const useStyles = tss.create(({ theme }) => ({
  assetRiskScoreIconButtonCancel: {
    height: '2rem',
    position: 'absolute',
    right: 8,
    top: 8,
    width: '2rem'
  },
  assetRiskScoreList: {
    padding: 0,
    gap: theme.spacing(2),
    display: 'flex',
    flexDirection: 'column'
  },
  assetRiskScoreListItem: {
    border: '1px solid',
    borderColor: theme.vars.palette.divider,
    flexDirection: 'column',
    alignItems: 'flex-start',
    borderRadius: '4px',
    backgroundColor: theme.vars.palette.background.elevation1,
    gap: theme.spacing(1)
  },
  assetRiskScoreStack: {
    alignItems: 'center',
    width: '100%',
    justifyContent: 'space-between'
  }
}));

export default useStyles;
